import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import Landing from "../components/Landing"
import Activity from "../components/Activity"
import Skills from "../components/Skills"
import Work from "../components/Work"
import Contact from "../components/Contact"
import Other from "../components/Other"
import End from "../components/End"
import SEO from "../components/seo"

import workStyles from "../components/work.module.css"

import graphGif from "../images/apigif.gif";
import caGif from "../images/caGif.gif";
import mlGif from "../images/mlGif.gif";
import blGif from "../images/blGif.gif";

const fakeData = {

  splashText: "Hey, I'm August. I love creating things.",
  projects: [
    {
      name: "Chord Sketcher",
      ghLink: "https://github.com/augustinevt/song_sketcher",
      liveLink: "http://chord-sketch.s3-website.us-east-2.amazonaws.com/",
      image: 'https://i.gyazo.com/62b807243c03fcf464f55daf04ff1e4c.gif',
      description: "A small app for generating chord progressions.",
      tags: ['Javascript', 'React']
    },
    {
      name: "Cell_Auto_Shop",
      ghLink: "https://github.com/augustinevt/cell_sys_workshop",
      liveLink: "http://cellular-auto-shop.s3-website.us-east-2.amazonaws.com/",
      image: 'https://i.gyazo.com/a6a4cab86ad5177de88dcaf6cd8467c6.gif',
      description: "Small web based app for exploring cellular automata.",
      tags: ['Javascript', 'Vue']
    },
    {
      name: "Textflow",
      ghLink: "https://github.com/augustinevt/textflow/projects/1",
      image: 'https://i.gyazo.com/23f1173fe4e32ba66736c0f83b6c86d4.gif',
      description: "Structered writing process and text editor app",
      tags: ['Javascript', 'React', 'Redux']
    },
    {
      name: "Graph-Deluxe",
      ghLink: "https://github.com/augustinevt/systemGraphUtility",
      image: 'https://i.gyazo.com/0ca2fe1860a653f94ea174b1a248ae5c.gif',
      description: "Graph Generator for quickly creating graphs with various topographies and other attributes",
      tags: ['Javascript']
    },
  ],

  skills: {
    coreSkills: [
      {label: 'Learning Speed', value: 70},
      {label: 'Problem Solving', value: 50},
      {label: 'Documentation', value: 30},
      {label: 'Algorithms', value: 50},
    ],

    moreSkills: [
      {label: 'Agile Proccess', value: 70},
      {label: 'Teamwork', value: 50},
      {label: 'Professionalism', value: 38},
    ],

    framework: [
      {label: 'Agile Proccess', value: 70},
      {label: 'Teamwork', value: 50},
      {label: 'Professionalism', value: 38},
    ]
  },

  activity: {
    jobs: [
      {
        company_name: 'Arizona State University',
        dates: 'October 2019 - Present',
        description: [
          'A continuing pursuit of my ongoing personal and proffessional development in technology.'
        ],
        title: 'Bachelors in Software Engineering',
      },
      {
        company_name: 'Portland Community College',
        dates: 'Janaury 2018 - September 2019',
        description: [
          'A continuing pursuit of my ongoing personal and proffessional development in technology.'
        ],
        title: 'Transfer Associates of Science',
      },
      {
        company_name: 'Monsoon, Inc.',
        dates: 'March 2016  - November 2018',
        description: [
          'Designed and developed the Front-End solutions for all company cloud native products. Working directly with the product development team, I took the functional and design requirements, broke them into technical specifications, then took responsibility for implementation and deployment.'
        ],
        title: 'Front-End Engineer',
      },
      {
        company_name: 'Reflect Technologies',
        dates: 'November 2016 - April 2017',
        description: ['Working alongside a small team of talented engineers, I contributed to the company\'s data visualization product. I moved quickly from my initial responsibility of managing the company marketing website to resolving issues reported by key clients in the heart of the codebase and implementing entire features in the client facing UI.'
        ],
        title: 'Front-End Engineer',
      },
      {
        company_name: 'Donuts.js',
        dates: 'June 2018 - Present',
        description: ['Contributed to administrative work and helped host events.'],
        title: 'Organizer',
      },

      {
        company_name: 'Epicodus',
        dates: 'June 2016 - October 2016',
        description: ['Used a vareity of full stack technologies in team based software development exercises.'],
        title: 'Ruby Developer Track',
      },
    ],


    volunteer: [,

    {
      company_name: 'Portland Community College',
      dates: 'November 2016 - April 2017',
      description: [
        'Studied general requirements'
      ],
      title: 'Student',
    }]
  },

  quotes: {
    farrah: {
      text: "August is a smart, effective person",
      name: "Farrah Cample",
      title: "Office person",
    },

    bill: {
      text: "August is a smart, effective person",
      name: "Bill Tennent",
      title: "Pink Martini Manager",
    },

    micheal: {
      text: 'August was a critical member of our Cloud Native team at Monsoon, and continually generated value at every stage of our design and development process - from ideation all the way to implementation. He effectively lead the frontend engineering aspect of the project and was directly responsible for our choice of frontend technologies as well as delivering many features. I was always very impressed with August’s ability to quickly prototype a design or approach, share it with the team to gather feedback, and then immediately execute with a rock solid implementation. August has a very methodical and meticulous approach to his craft, and at the same time is able to remain surprising adaptive, agile and efficient. Any organization would greatly benefit from August’s design and engineering acumen and I look forward to seeing what he will accomplish in the future!',

      name: "Micheal Andrews",
      title: "CTO & Director of Data Engineering at Monsoon Inc.",
    }
  }
};

const splashQuote = fakeData.quotes.micheal;

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: { extension: { eq: "pdf" } }) {
        edges {
          node {
            publicURL
            name
          }
        }
      }
    }
  `)

  return <Layout>
    <SEO title="Home" />
    <Contact type="top"/>
    <Landing splashText={fakeData.splashText} splashQuote={fakeData.quotes.micheal}/>
    <Work projects={fakeData.projects.slice(0,4)} />

    <Skills
      coreSkills={fakeData.skills.coreSkills}
      moreSkills={fakeData.skills.moreSkills}
      frameworks={fakeData.skills.framworks}
    />

    <Activity
      jobs={fakeData.activity.jobs}
      education={fakeData.activity.education}
      volunteer={fakeData.activity.volunteer}
      splashQuote={splashQuote}
      quotes={[fakeData.quotes.farrah, fakeData.quotes.bill]}
    />

    <End resumeLink={`${data.allFile.edges[0].node.publicURL}`}/>

  </Layout>
}

export default IndexPage
